module.exports = __webpack_public_path__ + "img/home_carousel_image_2.b89dcf1d.png";